import { render, staticRenderFns } from "./ManufactureDetailsView.vue?vue&type=template&id=38121a80&"
import script from "./ManufactureDetailsView.vue?vue&type=script&lang=js&"
export * from "./ManufactureDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureDetailsView.vue?vue&type=style&index=0&id=38121a80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports